import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({
	// ...............................................

	buttonContainer: {
		padding: '1rem',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		marginTop: '3rem'
	},
	siteLevelSettings: {
		backgroundColor: '#fc4b58',
		color: 'white !important',
		boxShadow: '0 0 3px rgba(0, 0, 0, 0.3)',
		marginBottom: '1rem !important',
		padding: '1rem',
		borderRadius: '4px',
		cursor: 'pointer'
		// border: '2px solid blue',
	},

	modalContentStyle: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		width: '40% !important',
		height: '35% ',
		backgroundColor: '#fff',
		boxShadow: 24,
		borderRadius: '10px',
		padding: '1rem 2rem',
		textAlign: 'center'
	},
	modalContentItem: {
		display: 'flex',
		justifyContent: 'center'
	},
	icon: {
		cursor: 'pointer',
		transform: 'scale(1.5)',
		transition: 'all .3s ease !important',
		'&:hover': {
			transform: 'scale(1.55)'
		},
		'&:active': {
			transform: 'scale(1.3)'
		}
	},

	finalOverview: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		width: '70% !important',
		height: '70% ',
		backgroundColor: '#fff',
		boxShadow: 24,
		borderRadius: '10px',
		padding: '3rem',
		overflow: 'scroll',
		position: 'relative'
	}
}));
